import BaseComponent from "@js/components/base_component.jsx";

import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "@js/components/eui/modal/index.js";

class TwoFactor extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  render() {
    const allowEditUsers = this.props.library.system_configuration.allow_edit_engine_users;
    const isUserSelf = this.props.library.current_user && this.props.library.current_user.id && this.props.library.current_user.id === this.props.entity.id;
    const hasOtpSecret = this.props.entity.has_otp_secret;
    const isEditing = this.props.editing;
    const supportAddingTwofactor = isUserSelf;

    if ( isEditing ) return null;

    return (
      <FieldContainer labelText="Two-factor authentication">
        {
          ( !isUserSelf && !allowEditUsers ) ? (
            hasOtpSecret ? (
              t("twofactor.is_enabled")
            ) : (
              t("twofactor.is_not_enabled")
            )
          ) : (
            hasOtpSecret ? (
              <RemoveTwoFactorAuthentication
                user_id={ this.props.entity.id }
                user_email={ this.props.entity.email }
              />
            ) : supportAddingTwofactor ? (
              <a href={ Routes.new_eui_two_factor_authentication_path({ return_to: window.location.href }) }>
                { t("twofactor.enable") }
              </a>
            ) : (
              t("twofactor.is_not_enabled")
            )
          )
        }
      </FieldContainer>
    );
  }

}

class RemoveTwoFactorAuthentication extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      removing: false,
    };
  }

  render() {
    return (
      <div>
        <a
          onClick={ (e) => { e.preventDefault(); this._startRemoving(e); } }
          id="remove-twofactor"
          href="#"
        >
          { t("twofactor.remove.button") }
        </a>
        {
          this.state.removing && (
            <Modal>
              <ModalHeader onCancel={ this._stopRemoving }>
                { t("twofactor.remove.confirm_title") }
              </ModalHeader>
              <ModalBody>
                { t("twofactor.remove.confirm_body") }
              </ModalBody>
              <ModalFooter>
                <ModalButton onClick={ this._stopRemoving }>{ t("buttons.cancel") }</ModalButton>
                <ModalButton onClick={ this._doRemove } dangerous={ true }>{ t("buttons.remove") }</ModalButton>
              </ModalFooter>
            </Modal>
          )
        }
      </div>
    );
  }

  _startRemoving() {
    this.setState({
      removing: true,
    });
  }

  _stopRemoving() {
    this.setState({
      removing: false,
    });
  }

  _doRemove() {
    Turbolinks.visit(
      Routes.remove_two_factor_authentication_eui_user_path(this.props.user_id, { return_to: window.location.href })
    );
  }

}

export default TwoFactor;
